import icAddSquare from 'assets/images/ic-add-square.svg'
import { Button, InlineError, Input } from 'avo-ui'
import MultipleSelect from 'components/commons/multiple-select'
import TabToggle from 'components/commons/tab-toogle'
import TabToggleList from 'components/commons/tab-toogle-list'
import UploadImage from 'components/commons/upload-image'

export const NominationVoting = ({
    data,
    items,
    errorForm,
    optionsNominee,
    setItems,
    onChangeForm,
    onChangeItem,
    onAddNewItem,
    onSearchNominee,
    onSubmit,
    isLoading,
}) => {
    const getError = (key, index) => {
        const findError = errorForm?.claims_detail?.find((i) => i?.index === index && i?.key === key)
        return findError?.message
    }

    return (
        <div className={'flex flex-col space-y-6'}>
            <TabToggle
                title={'General'}
                content={
                    <div className={'flex space-x-16'}>
                        <div
                            className={`flex-1 flex-col ${(data?.title_image_url?.base64 || data?.title_image_url) && 'space-y-3'}`}
                        >
                            <div className={'font-semibold text-blue-90 required'}>Image Title</div>
                            <UploadImage
                                className={'w-fit'}
                                classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                                id={'image-title'}
                                value={data?.title_image_url?.base64 || data?.title_image_url}
                                onChange={(value) => onChangeForm({ name: 'title_image_url', value })}
                            />
                            <InlineError className='mt-2' message={errorForm?.title_image_url} />
                        </div>
                        <div
                            className={`flex-1 flex-col ${(data?.mini_banner_url?.base64 || data?.mini_banner_url) && 'space-y-3'}`}
                        >
                            <div className={'font-semibold text-blue-90'}>Mini Banner</div>
                            <UploadImage
                                className={'w-fit'}
                                classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                                id={`mini-banner`}
                                value={data?.mini_banner_url?.base64 || data?.mini_banner_url}
                                onChange={(value) => onChangeForm({ name: 'mini_banner_url', value })}
                            />
                        </div>
                    </div>
                }
            />
            <div className={'flex flex-col space-y-6'}>
                {items?.map((item, index) => (
                    <TabToggleList
                        key={`category-${index}`}
                        index={index}
                        title={`Nomination-${index + 1}`}
                        content={
                            <div className={'flex space-x-16'}>
                                <div className={'flex-1 flex-col space-y-3'}>
                                    <div className={'font-semibold text-blue-90 required'}>Title</div>
                                    <Input
                                        className={'flex-1'}
                                        name={'name'}
                                        placeholder={'Masukkan title'}
                                        value={item?.name}
                                        onChange={(item) => onChangeItem({ ...item, index })}
                                    />
                                    <InlineError className='mt-2' message={errorForm?.nominations?.[index]?.name} />
                                </div>
                                <div className={'flex-1 flex-col space-y-3'}>
                                    <div className={'font-semibold text-blue-90 required'}>Pilih Nominee</div>
                                    <MultipleSelect
                                        name={'nominee_ids'}
                                        placeholder={'Search Nominee...'}
                                        onSearch={onSearchNominee}
                                        value={item?.nominee_ids}
                                        options={optionsNominee}
                                        onChange={(item) => onChangeItem({ ...item, index })}
                                    />
                                    <InlineError
                                        className='mt-2'
                                        message={errorForm?.nominations?.[index]?.nominee_ids}
                                    />
                                </div>
                            </div>
                        }
                        items={items}
                        setItems={setItems}
                    />
                ))}
                <Button
                    className={'w-fit'}
                    type={'outline'}
                    icon={icAddSquare}
                    title={'Add New Item'}
                    onClick={onAddNewItem}
                />
            </div>
            <div className={'flex py-3 justify-center'}>
                <Button className={'w-[200px]'} loading={isLoading} title={'Submit'} onClick={onSubmit} />
            </div>
        </div>
    )
}
